// extracted by mini-css-extract-plugin
export var info = "style-module--info--f0017";
export var list = "style-module--list--77999";
export var speakers = "style-module--speakers--17ad2";